import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/SMA_Inverter.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="SMA String Inverter" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Inverters/SMA.js